import { Instagram, Linkedin, Youtube } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_0614d46d-eee4-4b28-994f-37db8280bda0/artifacts/3ew9qzg8_Bring%20me%20cash%20-%20logo.png";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer id="footer" className="bg-black text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-start gap-10 pb-10 border-b border-white/15">
          <div>
            <img src={LOGO_URL} alt="Bring Me Cash" className="h-9 w-auto brightness-0 invert mb-4" />
            <p className="font-['Ubuntu'] text-white/60 text-sm max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-instagram"
              className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#F15BB5] hover:border-[#F15BB5] transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-linkedin"
              className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#00BBF9] hover:border-[#00BBF9] transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-youtube"
              className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[#FFE440] hover:text-black hover:border-[#FFE440] transition-colors"
            >
              <Youtube className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 font-['Ubuntu'] text-xs text-white/50">
          <div className="flex gap-6">
            {t.footer.legal.map((l, i) => (
              <span key={i} className="hover:text-white cursor-pointer">
                {l}
              </span>
            ))}
          </div>
          <p>© {new Date().getFullYear()} Bring Me Cash — {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
